export type FieldType =
  | "dashboard"
  | "utilisateurs"
  | "entreprises"
  | "factures"
  | "messages"
  | "parametres";
type Authorization = {
  value: FieldType;
  label: string;
  path: string;
};
export const Authorisations: Authorization[] = [
  {
    value: "dashboard",
    label: "Dashboard",
    path: "/admin/dashboard",
  },
  {
    value: "utilisateurs",
    label: "Clients",
    path: "/admin/utilisateurs",
  },
  {
    value: "entreprises",
    label: "Entreprise",
    path: "/admin/proprietaires",
  },
  {
    value: "factures",
    label: "Factures",
    path: "/admin/factures",
  },
  {
    value: "messages",
    label: "Messagerie",
    path: "/admin/messagerie",
  },
  {
    value: "parametres",
    label: "Paramètres",
    path: "/admin/parametres",
  },
];

// Lien de souscription RevenueCat Web Billing (paiement Stripe), suivi de
// l'UID Firebase de l'utilisateur : c'est ce qui rattache le paiement à son
// compte. Même base que SUBSCRIPTION_URL de l'app mobile en production
// (fast-facture-mobile, utils/api/api.ts).
export const SUBSCRIPTION_URL = "https://pay.rev.cat/xvwdgvsasdzqzgrx";

export function getSubscriptionLink(uid: string): string {
  return `${SUBSCRIPTION_URL}/${encodeURIComponent(uid)}`;
}
